export default __webpack_public_path__ + "static/media/medicine.f6635fb5.jpg";